export interface ITableFilterDef<T> {
    filterKey: string;
    filterGroup: {
        [groupName: string]: Array<T>;
    };
    translations: {
        [groupName: string]: string;
    };
}

export class TableFilterDef<T> implements ITableFilterDef<T> {
    public filterKey: string;
    public filterGroup: {
        [groupName: string]: Array<T>;
    };
    public translations: {
        [groupName: string]: string;
    };

    constructor(params: ITableFilterDef<T>) {
        Object.assign(this, params);
    }
}
